import TextField from "@material-ui/core/TextField";
import { IconButton, InputAdornment } from "@material-ui/core";
import { VpnKey, Language, AccountCircle, Visibility, VisibilityOff } from "@material-ui/icons";
import React, { useState } from "react";
import styled, { keyframes } from "styled-components";

function TabApiCredenciaisIFS({ values, touched, errors, handleChange }) {
  const [showSecret, setShowSecret] = useState(false);

  return (
    <ModernFormContainer>
      {values.id && (
        <SectionCard>
          <SectionHeader>
            <SectionIcon color="#ff6b35">
              <Language />
            </SectionIcon>
            <SectionTitle>Configurações IFS</SectionTitle>
          </SectionHeader>
          <FormGrid columns={1}>
            <StyledFieldContainer>
              <FieldLabel>
                <Language style={{ fontSize: '18px', marginRight: '8px', color: '#ff6b35' }} />
                URL IFS
              </FieldLabel>
              <TextField
                fullWidth
                InputLabelProps={{ shrink: true }}
                id="ifs_url"
                name="ifs_url"
                placeholder="https://ifs.example.com"
                value={values.ifs_url}
                onChange={handleChange}
                error={touched.ifs_url && Boolean(errors.ifs_url)}
                helperText={touched.ifs_url && errors.ifs_url}
                autoComplete="off"
                variant="outlined"
              />
            </StyledFieldContainer>
          </FormGrid>
        </SectionCard>
      )}

      {values.id && (
        <SectionCard>
          <SectionHeader>
            <SectionIcon color="#8e44ad">
              <VpnKey />
            </SectionIcon>
            <SectionTitle>Autenticação IFS API</SectionTitle>
          </SectionHeader>

          <FormGrid columns={1}>
            <StyledFieldContainer>
              <FieldLabel>
                <Language style={{ fontSize: '18px', marginRight: '8px', color: '#8e44ad' }} />
                URL do Token OAuth
              </FieldLabel>
              <TextField
                fullWidth
                InputLabelProps={{ shrink: true }}
                id="ifs_token_url"
                name="ifs_token_url"
                placeholder="https://{env}.build.ifs.cloud/auth/realms/{realm}/protocol/openid-connect/token"
                value={values.ifs_token_url}
                onChange={handleChange}
                error={touched.ifs_token_url && Boolean(errors.ifs_token_url)}
                helperText={touched.ifs_token_url && errors.ifs_token_url}
                autoComplete="off"
                variant="outlined"
              />
            </StyledFieldContainer>
          </FormGrid>

          <FormGrid columns={2} style={{ marginTop: '20px' }}>
            <StyledFieldContainer>
              <FieldLabel>
                <AccountCircle style={{ fontSize: '18px', marginRight: '8px', color: '#8e44ad' }} />
                Client ID
              </FieldLabel>
              <TextField
                fullWidth
                InputLabelProps={{ shrink: true }}
                id="ifs_client_id"
                name="ifs_client_id"
                placeholder="IFS_CLIENT_ID"
                value={values.ifs_client_id}
                onChange={handleChange}
                error={touched.ifs_client_id && Boolean(errors.ifs_client_id)}
                helperText={touched.ifs_client_id && errors.ifs_client_id}
                autoComplete="off"
                variant="outlined"
              />
            </StyledFieldContainer>

            <StyledFieldContainer>
              <FieldLabel>
                <VpnKey style={{ fontSize: '18px', marginRight: '8px', color: '#e74c3c' }} />
                Client Secret
              </FieldLabel>
              <TextField
                fullWidth
                InputLabelProps={{ shrink: true }}
                id="ifs_client_secret"
                name="ifs_client_secret"
                placeholder="Client Secret"
                type={showSecret ? "text" : "password"}
                value={values.ifs_client_secret}
                onChange={handleChange}
                error={touched.ifs_client_secret && Boolean(errors.ifs_client_secret)}
                helperText={touched.ifs_client_secret && errors.ifs_client_secret}
                autoComplete="off"
                variant="outlined"
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton onClick={() => setShowSecret((v) => !v)} edge="end">
                        {showSecret ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
            </StyledFieldContainer>
          </FormGrid>
        </SectionCard>
      )}
    </ModernFormContainer>
  );
}

export default TabApiCredenciaisIFS;

// Animações
const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

const ModernFormContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  font-family: 'Mulish', sans-serif;
`;

const SectionCard = styled.div`
  background: white;
  border-radius: 16px;
  padding: 24px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  border: 1px solid #e8e8e8;
  animation: ${fadeIn} 0.5s ease;
  transition: all 0.3s ease;

  &:hover {
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    border-color: #d0d0d0;
  }
`;

const SectionHeader = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  padding-bottom: 16px;
  border-bottom: 2px solid #f0f0f0;
`;

const SectionIcon = styled.div`
  width: 40px;
  height: 40px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${props => props.color ? `${props.color}15` : '#8e44ad15'};
  color: ${props => props.color || '#8e44ad'};
  margin-right: 12px;
  transition: all 0.3s ease;

  svg {
    font-size: 22px;
  }

  ${SectionCard}:hover & {
    transform: scale(1.1);
  }
`;

const SectionTitle = styled.h3`
  font-size: 18px;
  font-weight: 700;
  color: #2c3e50;
  margin: 0;
  font-family: 'Mulish', sans-serif;
`;

const FormGrid = styled.div`
  display: grid;
  grid-template-columns: ${props => props.columns === 2 ? 'repeat(2, 1fr)' : '1fr'};
  gap: 20px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

const StyledFieldContainer = styled.div`
  display: flex;
  flex-direction: column;

  .MuiOutlinedInput-root {
    border-radius: 10px;
    transition: all 0.3s ease;

    &:hover {
      box-shadow: 0 2px 8px rgba(142, 68, 173, 0.1);
    }

    &.Mui-focused {
      box-shadow: 0 4px 12px rgba(142, 68, 173, 0.2);
    }
  }

  .MuiInputLabel-outlined {
    font-family: 'Mulish', sans-serif;
    font-weight: 500;
  }

  .MuiOutlinedInput-input {
    font-family: 'Mulish', sans-serif;
  }
`;

const FieldLabel = styled.label`
  font-size: 14px;
  font-weight: 600;
  color: #2c3e50;
  margin-bottom: 8px;
  display: flex;
  align-items: center;
  font-family: 'Mulish', sans-serif;
`;
